<template>
	<div class="content">
        <container v-if="!loaded"><loading /></container>
        <div class="md-layout" v-if="loaded">
            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px;display: flex;align-items: center;">
            	<h4 class="application-title" style="font-weight: bold;">{{translate(locale.manage_flow)}}</h4>
        	</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-40 md-medium-size-40 md-size-33" style="display: flex;">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-center">
							<div class="text-primary" style="margin-bottom: 15px"><b>{{translate(locale.unit)}}</b></div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="unit in unit_list">
							<div class="unit-item">
								<div>{{unit.name}} ‎ ‎ ({{unit.total_user || 0}} {{translate("people||នាក់")}})</div>
								<div><md-button class="md-raised md-primary" @click="add(unit)"><i class="material-icons button-icon">add</i> {{translate(locale.add)}}</md-button></div>
							</div>
						</div>
					</div>
				</container>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-60 md-medium-size-60 md-size-66" style="display: flex;">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-center">
							<div class="text-primary"><b>{{service.name}}</b></div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<div class="unit-flow-container">
								<div v-for="(unit, index) in service.flow_list">
									<div class="unit-card">
										<div class="flow-name">{{index+1}}. {{unit.name}}</div>
										<div class="flow-action">
											<!-- <md-button class="md-just-icon md-secondary" @click="up(index)"><i class="material-icons">arrow_drop_up</i></md-button>
											<md-button class="md-just-icon md-secondary" style="margin-left:5px" @click="down(index)"><i class="material-icons">arrow_drop_down</i></md-button> -->
											<md-button class="md-raised md-danger" style="margin-left:5px" @click="remove(index)"><i class="material-icons button-icon">remove</i> {{translate(locale.delete)}}</md-button>
										</div>
									</div>
									<div class="flow-container" v-if="index < service.flow_list.length - 1"><i class="material-icons flow-icon">arrow_downward</i></div>
								</div>
								
							</div>
						</div>
						
					</div>
				</container>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
				<container>
					<md-button class="md-raised md-primary" @click="updateFlow()"><i class="material-icons button-icon">save</i> {{translate(locale.save)}}</md-button>
				</container>
			</div>
        </div>
    </div>

</template>

<script>

	export default {
		created() {
			this.getUnit();
		},

		data() {
			return {
				loaded: false,
				service: {
					name: "",
					flow_list: []
				},
				unit_list: [],
				errors: []
			}
		},
		methods: {
			getUnit(more = false) {
				this.$http.post(this.config.api + "/user/unit/list").then(data => {
					this.unit_list = data.body.data;
					this.getService();
				})
			},
			getService() {
				this.$http.get(this.config.api + "/user/flow/get/" + this.$route.params.hash).then(data => {
					this.service.name = data.body.data.service_name;
					this.service.flow_list = data.body.data.service_flow_list;
					
					this.loaded = true;
				});
			},
			updateFlow() {

				this.$http.post(this.config.api + "/user/flow/update", {
					hash: this.$route.params.hash,
					service_flow_list: this.service.flow_list
				}).then(res => {
					if(res.body.status == 'success') {
						// this.$notification.notify({
						// 	message: "You have update an account successfully.||អ្នកបានកែប្រែគណនីគ្រប់គ្រងដោយជោគជ័យ។",
						// 	icon: 'check_circle',
						// 	type: 'success'
						// });

						this.$router.push("/flows");
					}
				})
			},
			add(unit) {

				if(this.service.flow_list.length == 0 || this.service.flow_list[this.service.flow_list.length - 1].id != unit.id) { 
					this.service.flow_list.push({id: unit.id, name: unit.name});
				 }
			},
			remove(index) {
				this.service.flow_list.splice(index, 1);
			},
			up(index) {
				if(index < 1) return false;

				let tmp = this.service.flow_list[index];
				this.service.flow_list[index] = this.service.flow_list[index - 1];
				this.service.flow_list[index - 1] = tmp;
			},
			down(index) {

			}
		}
	}
</script>

<style scoped>

	.flow-container {
		width: 100%; 
		text-align: center;
		color: #353690;
	}
	.unit-flow-container {
		margin-top: 25px;
	}
	.unit-card {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 15px 30px;
		border-radius: 6px;
		border: 1px solid #353690;
		margin: 15px 0;
		color: #353690;
		text-align: center;
		font-weight: bold;
	}
	.unit-item {
		color:#353690; 
		font-weight: bold; 
		display: flex; 
		align-items: center; 
		justify-content: space-between;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Flows/Edit.vue